import { render, staticRenderFns } from "./telephone-action-history.vue?vue&type=template&id=7945a84c&scoped=true"
import script from "./telephone-action-history.vue?vue&type=script&lang=ts"
export * from "./telephone-action-history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7945a84c",
  null
  
)

export default component.exports